/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_Geen_EigenInputs */

const nl_planning_vakanties_geen_eigen = /** @type {(inputs: Planning_Vakanties_Geen_EigenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen eigen vrije dagen.`)
};

/**

* @param {Planning_Vakanties_Geen_EigenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_geen_eigen = /** @type {((inputs?: Planning_Vakanties_Geen_EigenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Geen_EigenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_geen_eigen(inputs)
});
export { planning_vakanties_geen_eigen as "planning.vakanties.geen_eigen" }